@if (initialized && overviewDto) {

  <div class="p-5 border-round-lg mb-5 relative"
       style="background-image: linear-gradient(to bottom right, #407192 , #40C8C8);">

    <div class="grid">
      <div class="lg:col-9 col-12">
        <h3 class="mb-2 font-semibold text-0">Empfehle uns weiter</h3>
        <span class="text-0">Link kopieren und teilen</span>

        <div
          class="flex flex-wrap align-items-center my-4 gap-4 justify-content-between surface-0 border-1 border-300 border-round-lg p-3 xl:col-9">

          <span class="text-color-secondary lg:col-8"
                style="word-break: break-word;">{{ overviewDto.texts.referralMessageText }}</span>

          <button class="p-element p-ripple w-10rem p-button p-component justify-content-center"
                  (click)="handleCopyClipboard()"
                  pButton pRipple> Link kopieren
          </button>
        </div>

        <div class="flex flex-wrap gap-3">

          <button (click)="navigateToWhatsApp()" class="p-button p-component p-button-rounded p-button-text px-0"
                  style="width: 2.5rem; height: 2.5rem">
            <img src="../../../../assets/images/refer-whatsApp.svg" class="w-full text-green-300" alt="WhatsApp">
          </button>

          <button (click)="navigateToTelegram()" class="p-button p-component p-button-rounded p-button-text px-0"
                  style="width: 2.5rem; height: 2.5rem">
            <img src="../../../../assets/images/refer-telegram.svg" class="w-full text-green-300" alt="Telegram">
          </button>

          <button (click)="navigateToMessenger()" class="p-button p-component p-button-rounded p-button-text px-0"
                  style="width: 2.5rem; height: 2.5rem">
            <img src="../../../../assets/images/refer-fb-messenger.svg" class="w-full text-green-300" alt="Messenger">
          </button>

          <button (click)="navigateToFacebook()" class="p-button p-component p-button-rounded p-button-text px-0"
                  style="width: 2.5rem; height: 2.5rem">
            <img src="../../../../assets/images/refer-facebook.svg" class="w-full text-green-300" alt="Facebook">
          </button>

        </div>

      </div>

      <div class="lg:col-3 text-center align-self-center xl:block hidden">
        <!--          <i class="pi pi-gift text-primary" style="font-size: 150px"></i>-->
        <img src="../../../../assets/images/referral-gifts.png" class="absolute right-0 bottom-0">
      </div>

    </div>

  </div>

  <div class="card lg:p-5 p-3">
    <div>
      <div class="grid lg:p-2 border-1 border-300 border-round-lg lg:mx-5 mx-3 mt-3">
        <div class="lg:col-4 col-12 flex align-items-center
         border-right-1 lg:border-bottom-none border-bottom-1 border-300 py-3 px-5">
          <div class="flex flex-column gap-2">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-star text-purple-500 text-xl"></i>
              <span class="text-color-secondary">Meine Empfehlungen</span>
            </div>
            <span class="text-color font-bold">{{ overviewDto.score.remainingReferralCount }}</span>
          </div>
        </div>

        @if (overviewDto.score.pendingReferralCount) {
          <div class="lg:col-4 col-12 flex align-items-center
           border-right-1 lg:border-bottom-none border-bottom-1 border-300 py-3 px-5">
            <div class="flex flex-column gap-2">
              <div class="flex align-items-center gap-2">
                <i class="pi pi-clock text-blue-500 text-xl"></i>
                <span class="text-color-secondary">In Bearbeitung</span>
              </div>
              <span class="text-color font-bold">{{ overviewDto.score.pendingReferralCount }}</span>
            </div>
          </div>
        }

        @if (overviewDto.score.redeemedReferralCount) {
          <div class="lg:col-4 col-12 flex align-items-center
          lg:border-bottom-none border-bottom-1 border-300 py-3 px-5">
            <div class="flex flex-column gap-2">
              <div class="flex align-items-center gap-2">
                <i class="pi pi-gift text-green-500 text-xl"></i>
                <span class="text-color-secondary">Eingelöste Empfehlungen</span>
              </div>
              <span class="text-color font-bold">{{ overviewDto.score.redeemedReferralCount }}</span>
            </div>
          </div>
        }


      </div>

      <div class="flex flex-wrap gap-4 justify-content-between mt-5 col-12 lg:px-5 px-3 mb-3">
        <div>
          <h4 class="font-semibold mb-2">Deine Prämien</h4>
          <span class="text-color-secondary">{{ overviewDto.texts.euDescription }}</span>
        </div>
      </div>


      <div class="grid">

        @for (level of overviewDto.levels; track level.id) {

          <div class="xl:col-4 md:col-6 col-12 xl:px-5 xl:py-3 p-3">

            <div class="shadow-2 p-5 h-full flex flex-column surface-card" style="border-radius: 6px">
              <div class="flex flex-row justify-content-between mb-4 align-items-center gap-3">
                <div class="text-900 text-xl font-medium">{{ level.name }}</div>
                <!--<span class="bg-orange-100 500 text-orange-500 font-semibold px-2 py-1 border-round">1</span>-->
              </div>
              <div class="flex flex-column gap-4">
                <span class="text-color font-semibold text-4xl">{{ level.textHeader }}</span>
                <span class="font-medium text-500 refer-type-desc">{{ level.textBody }}</span>
              </div>

              @if (level.selectedOption) {

                <div
                  class="flex flex-column align-items-center justify-content-center gap-3 border-1 border-300 border-round-lg p-3 my-5">
                  <img src="{{level.selectedOption.imageUrl}}" class="h-4rem">
                  <div>{{ level.selectedOption.name }}</div>
                  <button (click)="onShowDialog(level)"
                          class="p-element p-ripple p-button p-component text-color surface-100 border-1 border-300 py-2"
                          pButton pRipple> Ändern
                  </button>
                </div>


              } @else {
                <div
                  class="flex flex-wrap align-items-center justify-content-between gap-3 border-1 border-300 border-round-lg p-3 my-5">

                  <button (click)="onShowDialog(level)"
                          class="p-element p-ripple p-button p-component justify-content-center text-color surface-100 border-1 border-300 py-2"
                          pButton pRipple> Auswählen
                  </button>

                </div>
              }


              <div class="text-center">
                <p-button
                  class="w-full justify-content-center h-3rem px-0"
                  styleClass="w-full h-3rem"
                  label="Einlösen"
                  icon="ml-3 pi pi-arrow-right"
                  iconPos="right"
                  pButton
                  pRipple
                  [disabled]="level.requiredCount > overviewDto.score.remainingReferralCount"
                  (onClick)="onShowRedeemDialog(level)"

                >
                </p-button>
              </div>

            </div>
          </div>
        }

      </div>

      @if (overviewDto.redeems && overviewDto.redeems.length > 0) {
        <div class="my-4 lg:px-5 px-3 ">
          <div class="flex align-items-center">
            <h4 class="font-semibold">Deine eingelösten Prämien</h4>
          </div>

          <p-table [value]="overviewDto.redeems">
            <ng-template pTemplate="header">
              <tr>
                <th>Gutschein</th>
                <th>Beschreibung</th>
                <th>Eingelöst am</th>
                <th>Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-redeem>
              <tr>
                <td>
                  <div class="flex align-items-center">
                    <img [src]="redeem.redeemedOption.imageUrl" class="h-2rem">
                    <span class="mx-2">{{ redeem.redeemedOption.name }}</span>
                  </div>
                </td>
                <td>-</td>
                <td>-</td>
                <td>
                  <p-tag styleClass="p-2" severity="warning" icon="pi pi-circle-fill pr-1"
                         [value]=" redeem.redeemStatus | redeemStatusTranslate" [rounded]="true"></p-tag>
                </td>
              </tr>
            </ng-template>
          </p-table>


        </div>
      }
    </div>

  </div>

}

<p-dialog header="Header" [(visible)]="referDialog" [modal]="true" [style]="{ width: '50rem' }"
          [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <ng-template pTemplate="header">
    <div class="inline-flex align-items-center justify-content-center gap-2">
      <span class="font-bold white-space-nowrap text-xl">{{ selectedLevel?.name }}</span>
    </div>
  </ng-template>
  <h5 class="text-center mb-1">Wähle eine Option</h5>
  <!--<p class="text-color-secondary text-center">Volutpat est velit egestas dui id ornare arcu odio. Amet dictum sit amet justo.</p>-->
  <div class="grid mx-0 mt-4">

    @for (option of selectedLevel?.options; track option.id) {
      <div class="xl:col-4 md:col-6 col-12 mb-3">
        <div class="px-2 py-4" [ngClass]="selectedLevelOptionId == option.id ? 'border-bottom-2 border-blue-300' : 'border-bottom-1 border-200'">
          <div class="flex flex-column align-items-center">
            <label class="flex flex-column align-items-center gap-2 cursor-pointer">
              <img src="{{option.imageUrl}}" class="h-4rem mb-3" style="object-fit: contain"/>
              <span class="refer-type-desc">
               {{ option.name }}
             </span>
              <p-radioButton name="selectedOption" [value]="option.id"
                             [(ngModel)]="selectedLevelOptionId"></p-radioButton>
            </label>
          </div>
        </div>
        <span class="text-base text-color-secondary p-3 block text-center line-height-3">{{ option.textBody}} </span>
      </div>
    }
  </div>
  <ng-template pTemplate="footer">
    <!--    <p-button icon="pi pi-check" (click)="saveSelection()" [disabled]="!this.selectedLevelOptionId" label="Speichern"-->
    <!--              pAutoFocus></p-button>-->
    <app-button [busy]="busy"
                pAutoFocus
                [disabled]="!this.selectedLevelOptionId"
                [label]="'Speichern'"
                [icon]="'pi pi-check'"
                (onClick)="saveSelection()">
    </app-button>
  </ng-template>
</p-dialog>


<p-dialog [(visible)]="redeemDialog" [modal]="true" [style]="{ width: '35rem'}">
  <ng-template pTemplate="headless">
    <div class="surface-0 p-4 border-round-lg">
      <div class="flex justify-content-center">
    <span class="bg-green-500 p-5 border-circle">
      <i class="pi pi-gift text-0 text-2xl"></i>
    </span>
      </div>
      <h5 class="text-center text-color font-semibold text-xl my-4">
        Sind Sie sicher, dass Sie den Gutschein einlösen möchten?</h5>
      <p class="text-color-secondary text-center">
        Bitte beachten Sie, dass Sie nach der Einlösung dieses Produkts kein anderes Produkt zur Einlösung auswählen
        können.
        Wenn Sie mit dieser Aktion fortfahren, wird Ihre Auswahl abgeschlossen.
      </p>
      <div class="grid pt-4 border-top-1 border-200">
        <!--     (onClick)="redeem(level)"-->
        <div class="col-6">
          <p-button icon="pi pi-times" styleClass="w-full surface-0 text-500" class="w-full" (onClick)="onHideDialog()"
                    label="Cancle"></p-button>
        </div>
        <div class="col-6">
          <p-button icon="pi pi-check" styleClass="w-full" class="w-full" *ngIf="selectedLevel"
                    (onClick)="redeem(selectedLevel)" label="Confirm"
                    pAutoFocus></p-button>
        </div>

      </div>
    </div>
  </ng-template>
</p-dialog>

